import { Skeleton } from '@chakra-ui/react'

const LayoutSkeleton = () => {
  return <Skeleton h="131px" />
}

export default LayoutSkeleton
